export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/src/root.js
// module id = ./node_modules/d3-quadtree/src/root.js
// module chunks = 53